<template>
  <section class="us-market">
    <a-menu v-model="board" class="board-tabs" mode="horizontal"><a-menu-item key="overview">行情</a-menu-item><a-menu-item key="china">中概股</a-menu-item><a-menu-item key="tech">美股科技股</a-menu-item></a-menu>
    <div v-if="error && board[0] === 'overview'" role="alert">{{ error }} <button type="button" @click="load">重试</button></div>
    <div v-show="board[0] === 'overview'" class="us-overview">
    <div class="market-summary">
      <section class="index-panel"><USMinuteChart :active="board[0] === 'overview'" :indexes="overview.indexes" /></section>
      <section class="breadth-panel">
        <HongKongMarketBreadth :loading="summaryLoading && !today.diagram" :diagram="today.diagram || []" :ratio="today.ratio || {}" />
        <div v-if="summaryError" class="panel-error" role="alert">{{ summaryError }} <button type="button" @click="load">重试</button></div>
      </section>
      <USIndustryPanel :active="board[0] === 'overview'" @select-stock="openTrade" />
    </div>
    <div class="rank-title"><span>指数成分股</span><div v-if="rankPanelCount > 3"><button type="button" aria-label="上一组成分股" @click="scrollRanks(-1)">‹</button><button type="button" aria-label="下一组成分股" @click="scrollRanks(1)">›</button></div></div>
    <div ref="rankGrid" class="rank-grid" tabindex="0" aria-label="美股分类列表">
        <USConstituentPanel :active="board[0] === 'overview'" index="dji" title="道琼斯成分股" @select-stock="openTrade" />
        <USConstituentPanel :active="board[0] === 'overview'" index="nasdaq" title="纳斯达克综合成分股" @select-stock="openTrade" />
        <USConstituentPanel :active="board[0] === 'overview'" index="sp500" title="标普500成分股" @select-stock="openTrade" />
    </div>
    </div>
    <section v-for="category in ['china', 'tech']" :key="category" v-show="board[0] === category" class="board-panel">
      <USBoardTable :category="category" :active="board[0] === category" @select-stock="openTrade" />
    </section>
    <USTradePanel v-if="tradeStock" :key="tradeStock.code" :stock="tradeStock" @close="tradeStock = null" />
  </section>
</template>
<script>
import { getUSOverview } from '@/utils/usQuotes'
import { getUSMarketSummary } from './usApi'
import { stockSelection } from '../stock/stockSelection'
import { pollMarket } from '@/utils/marketRefresh'
import USMinuteChart from './components/USMinuteChart.vue'
import HongKongMarketBreadth from './components/HongKongMarketBreadth.vue'
import USIndustryPanel from './components/USIndustryPanel.vue'
import USConstituentPanel from './components/USConstituentPanel.vue'
import USTradePanel from './components/USTradePanel.vue'
import USBoardTable from './components/USBoardTable.vue'
import rankNavigation from './rankNavigation'
export default {
  mixins: [rankNavigation],
  name: 'USMarket',
  components: { USMinuteChart, HongKongMarketBreadth, USIndustryPanel, USConstituentPanel, USTradePanel, USBoardTable },
  data: () => ({ overview: { indexes: [], industries: [], ranks: {} }, today: {}, board: ['overview'], loading: false, summaryLoading: false, summaryError: '', error: '', tradeStock: null, sequence: 0, timer: null, disposed: false }),
  watch: { board() { this.stopPolling(); if (this.board[0] === 'overview') this.activate() } },
  mounted() { this.activate() },
  beforeDestroy() { this.disposed = true; this.sequence++; this.stopPolling() },
  methods: {
    stopPolling() { if (this.stopRefresh) this.stopRefresh(); this.stopRefresh = null },
    async activate() {
      if (this.disposed || this.board[0] !== 'overview' || this.stopRefresh) return
      try { await this.load() }
      finally {
        if (!this.disposed && this.board[0] === 'overview' && !this.stopRefresh) this.stopRefresh = pollMarket(() => this.load(true), 'us')
      }
    },
    openTrade(item) { const stock = stockSelection({ ...item, market: 'us' }); if (/^us[A-Za-z0-9][A-Za-z0-9._-]{0,39}$/.test(stock.code)) this.tradeStock = stock },
    async load(refresh = false) {
      refresh = refresh === true
      if (refresh && this.board[0] !== 'overview') return
      if (this.disposed || this.board[0] !== 'overview' || this.loading || this.summaryLoading) return
      const sequence = ++this.sequence
      this.loading = true; this.summaryLoading = true; this.error = ''; this.summaryError = ''
      const current = () => !this.disposed && sequence === this.sequence
      await Promise.all([
        getUSOverview().then(value => { if (current() && value) this.overview = value })
          .catch(() => { if (current()) this.error = '美股板块列表暂时无法加载，请重试。' })
          .finally(() => { if (current()) this.loading = false }),
        (this.board[0] !== 'overview' ? Promise.resolve(null) : getUSMarketSummary()).then(value => {
          if (!value) return
          const summary = value && (value.data || value)
          if (!summary || !Array.isArray(summary.diagram)) throw new Error('Invalid market summary')
          if (current()) this.today = summary
        }).catch(() => { if (current()) this.summaryError = '市场分布暂未更新，请重试。' })
          .finally(() => { if (current()) this.summaryLoading = false })
      ])
    }
  }
}
</script>
<style scoped>
.us-market { min-width: 1100px; flex: 1; min-height: 0; display: flex; flex-direction: column; padding: 0; background: var(--theme-bg); color: var(--theme-text); }
.us-overview { flex: 1; min-height: 0; display: flex; flex-direction: column; }
.market-summary, .rank-grid { display: grid; gap: 4px; }
.market-summary { grid-template-columns: repeat(3, minmax(0, 1fr)); flex-shrink: 0; height: max(38.6vh, calc(34.495vh + 36px)); }
.index-panel { min-width: 0; padding: 0; background: var(--theme-bg); }
.breadth-panel { position: relative; min-width: 0; min-height: 0; }
.breadth-panel .hk-breadth { height: 100%; }
.panel-error { position: absolute; bottom: 4px; left: 8px; right: 8px; color: var(--theme-muted); font-size: 12px; text-align: center; }
.board-panel { display: flex; flex: 1; min-height: 0; min-width: 0; }
.rank-row, .rank-header { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); align-items: center; width: 100%; height: 31px; padding: 0 11px; color: var(--theme-label); text-align: center; font-size: 14px; }
.rank-row span, .rank-header span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.rank-row[role="button"] { cursor: pointer; }
.rank-title { display: flex; align-items: center; justify-content: space-between; flex: 0 0 35px; line-height: 35px; margin: 5px 0; padding: 0 8px; color: var(--theme-text); font-size: 14px; }
.rank-grid { flex: 1; min-height: 0; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 15px; overflow: hidden; padding-bottom: 5px; }
.rank-grid.single-list { grid-template-columns: minmax(0, 1fr); }
.rank-panel { min-width: 0; min-height: 0; display: flex; flex-direction: column; scroll-snap-align: start; background: var(--theme-bg); }
.rank-body { flex: 1; min-height: 0; overflow-y: auto; scrollbar-width: thin; scrollbar-color: #c1c1c1 #eee; }
.rank-header { position: sticky; top: 0; z-index: 1; background: var(--theme-bg); }
.rank-body::-webkit-scrollbar { width: 6px; background: #eee; }
.rank-body::-webkit-scrollbar-thumb { background: #c1c1c1; border-radius: 8px; }
.rise { color: var(--quote-up); } .fall { color: var(--quote-down); } .flat { color: #9da6b3; }
.empty, .market-state { padding: 40px 0; color: #9da6b3; text-align: center; }
.market-state { min-height: 220px; }
</style>

<style>
.us-market .board-tabs {
  flex-shrink: 0;
  margin-bottom: 0;
  background: var(--theme-header);
  border-bottom: 0 !important;
}
.us-market .board-tabs .ant-menu-item {
  min-width: 120px;
  color: var(--theme-label);
  text-align: center;
}
.us-market .board-tabs .ant-menu-item-selected,
.us-market .board-tabs .ant-menu-item-active,
.us-market .board-tabs .ant-menu-item:hover {
  color: var(--theme-text) !important;
  border-bottom: 2px solid var(--theme-text) !important;
}
</style>
